/* eslint-disable import/extensions */
import React, { PureComponent } from 'react';

import { Checkbox, Link } from '@philips-emr/tws-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { bool, eventListener, string } from '@philips-emr/tws-core/lib/component/prop-types';

import HpmsTermCheckboxAPI from '../../api/hpms-term-of-use/hpms-terms-of-use-api';

import './hpms-terms-of-use.scss';

@AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: HpmsTermCheckboxAPI })
export default class HpmsTermCheckbox extends PureComponent {

  static propTypes = {
    labelText: string,
    linkText: string,
    onClickCheckBox: eventListener,
    onClickLink: eventListener,
    enabled: bool,
  }

  state = {
    check: false,
  }

  onCheck() {
    this.setState({ check: !this.state.check });
    const { onClickCheckBox } = this.props;
    onClickCheckBox();
  }

  getLinks() {
    const { onClickLink, linkText } = this.props;
    return (
      <>
        <Link value={linkText} onClick={onClickLink} />
      </>
    );
  }
  render() {
    const { enabled, labelText } = this.props;

    return (
      <div className="c-hpms-term-checkbox__wrapper">
        <div className="c-hpms-term-checkbox__checkbox">
          {<Checkbox
            label={labelText}
            onChange={() => {
              this.onCheck();
            }}
            value={this.state.check}
            enabled={enabled}
          />}
        </div>
        <div className="c-hpms-term-checkbox__link">
          {this.getLinks()}
        </div>
      </div>
    );
  }

}
